// Only Object Key:Value can be saved and retrieve in session
const state = {
  reference: {
    referrerBranchCode: process.env.VUE_APP_REFERRER_BRANCH_CODE,
    switchOwnerReference: null,
  },
  quoteParams: {
    isQuoteParamsJourney: false,
    completionDate: null,
  }
};

const getters = {};

const actions = {
  initialiseSession({ commit }) {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      const value = sessionStorage.getItem(key);

      commit('updateState', { key, value: JSON.parse(value) });
    }
  },
  setItem({ commit }, { key, value }) {
    const newValue = Object.assign(state[key], { ...state[key], ...value })
    sessionStorage.setItem(key, JSON.stringify(newValue));
    commit('updateState', { key, newValue });
  }
};

const mutations = {
  updateState(state, { key, value }) {
    state[key] = Object.assign(state[key], value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
